import { render } from "./MyRatingsList.vue?vue&type=template&id=4ec59dd3&ts=true"
import script from "./MyRatingsList.vue?vue&type=script&lang=ts"
export * from "./MyRatingsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__